import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Detalle from "./pages/Detalle";
import Flowtone from "./pages/Flowtone";
import Store from "./pages/Store";
import StoreDetail from "./pages/StoreDetail";
import MyTones from "./pages/MyTones";
import MyContacts from "./pages/MyContacts";
import ToneSettings from "./pages/ToneSettings";
import MyProfile from "./pages/MyProfile";
import Faq from "./pages/Faq";
import SetRbt from "./pages/SetRbt";
import ChangeToneSetting from "./pages/ChangeToneSetting";
import Search from "./pages/Search";
import ProtectedRoute from "./components/ProtectedRoute";
import ScrollToTop from "./components/ScrollToTop";
import Promos from "./pages/Promos";

const App = () => {
  return (
    <BrowserRouter>
    <ScrollToTop />
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Navigate to="/flowtone/login" replace />} />
        <Route path="/flowtone/login" element={<Login />} />
        <Route path="/flowtone" element={<Flowtone />} />

        {/* Protected Routes */}
        <Route
          path="/flowtone/dashboard"
          element={
           <ProtectedRoute>
              <Dashboard />
           </ProtectedRoute>
            
          }
        />

        <Route
          path="/flowtone/detalle"
          element={
            <ProtectedRoute>
              <Detalle />
            </ProtectedRoute>
          }
        />

        <Route
          path="/flowtone/store"
          element={
            <ProtectedRoute>
              <Store />
            </ProtectedRoute>
          }
        />

        <Route
          path="/flowtone/storeDetail"
          element={
            <ProtectedRoute>
              <StoreDetail />
            </ProtectedRoute>
          }
        />

        <Route
          path="/flowtone/myTones"
          element={
            <ProtectedRoute>
              <MyTones />
            </ProtectedRoute>
          }
        />

        <Route
          path="/flowtone/myContacts"
          element={
            <ProtectedRoute>
              <MyContacts />
            </ProtectedRoute>
          }
        />

        <Route
          path="/flowtone/toneSetting"
          element={
            <ProtectedRoute>
              <ToneSettings />
            </ProtectedRoute>
          }
        />

        <Route
          path="/flowtone/profile"
          element={
            <ProtectedRoute>
              <MyProfile />
            </ProtectedRoute>
          }
        />

        <Route
          path="/flowtone/faq"
          element={
            <ProtectedRoute>
              <Faq />
            </ProtectedRoute>
          }
        />

        <Route
          path="/flowtone/setRbt"
          element={
            <ProtectedRoute>
              <SetRbt />
            </ProtectedRoute>
          }
        />

        <Route
          path="/flowtone/changeToneSetting"
          element={
            <ProtectedRoute>
              <ChangeToneSetting />
            </ProtectedRoute>
          }
        />

        <Route
          path="/flowtone/searchResults"
          element={
            <ProtectedRoute>
              <Search />
            </ProtectedRoute>
          }
        />

                <Route
          path="/flowtone/promos"
          element={
            <ProtectedRoute>
              <Promos />
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
